import { tickerItems } from "@/mocks/home";

export default function NewsTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="flex h-10 w-full items-center gap-4 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 text-xs tracking-wide text-accent-400">
          <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
          滚动快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {loopItems.map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="mx-6 flex items-center gap-1.5 text-xs text-background-100/90 md:text-sm"
              >
                <i className="ri-fire-line text-primary-400" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}